import { findAll } from "../utils/dom";

const PlayVideo = () => {
	const playVideo = findAll("[js-play-video]");
	if (!playVideo) return;

	playVideo.forEach((play) => {
		play.addEventListener("click", (e) => {
			console.log(e.target)
			if (e.target?.paused) {
				e.target.play()
			} else {
				e.target.pause()
			}

		})
	})

}

export default PlayVideo;